<template>
    <div class="PAMMPage">
        <page-navigate></page-navigate>
        <div class="PAMMHeader flex">
            <div class="PAMMHeaderMain">
                <h1 class="PAMMHeaderTitle super_large-80_bold md-title-32_bold word2">
                    化繁为简的<br>
                    PAMM解决方案
                </h1>
                <!-- <h2 class="PAMMHeaderDesc subtitle-20_regular md-body-14_regular">一键化繁为简，让投资者与资金管理者高效同频</h2> -->
                <a class="PAMMHeaderBtn primary-default_large  cursor-pointer" href="{$register}">
                    <span class="word3">立即申请</span>
                    <span class="iconfont icon-right"></span>
                </a>
            </div>
            <img class="PAMMHeaderModel pc" src="@/assets/image/PAMM/PAMMHeadModel.png" alt="">
            <img class="PAMMHeaderModel mobile" src="@/assets/image/PAMM/PAMMHeadModelM.png" alt="">
        </div>
        <div class="PAMMAccount">
            <div class=" contentBox">
                <h2 class="PAMMAccountTitle text-center title-48_bold md-title-24_bold scroll-fade-up word4">什么是 PAMM
                    账户？</h2>
                <h3 class="PAMMAccountDesc subtitle-20_regular md-footnote-regular_12 text-center scroll-fade-up word5">
                    PAMM（百分比分配管理模式），允许投资者将资金分配给资金管理者，双方按比例分配利润和报酬</h3>
                <div class="swiper PAMMAccountSwiper">
                    <div class="PAMMAccountCardList swiper-wrapper">
                        <div class="PAMMAccountCard swiper-slide scroll-fade-up">
                            <div class="PAMMAccountCardTop">
                                <img src="@/assets/image/PAMM/PAMMAccountCardModel1.png" alt="">
                                <div class="title-24_medium md-subtitle-20_medium word6">投资者</div>
                            </div>
                            <div class="PAMMAccountCardBottom">
                                <div class="PAMMAccountCardWordPart">
                                    <img src="@/assets/image/PAMM/PAMMAccountLogo1.svg" alt="">
                                    <div>
                                        <div
                                            class="PAMMAccountCardWordTitle subtitle-20_medium md-body-16_medium word7">
                                            多元选择</div>
                                        <div class="PAMMAccountCardWordDesc body-14_regular md-body-14_regular word8">
                                            将资金分配给多个PAMM账户，分散风险</div>
                                    </div>
                                </div>
                                <div class="PAMMAccountCardWordPart">
                                    <img src="@/assets/image/PAMM/PAMMAccountLogo2.svg" alt="">
                                    <div>
                                        <div
                                            class="PAMMAccountCardWordTitle subtitle-20_medium md-body-16_medium word9">
                                            参与灵活</div>
                                        <div class="PAMMAccountCardWordDesc body-14_regular md-body-14_regular word10">
                                            随时跟随或解绑您关注的策略账户</div>
                                    </div>
                                </div>
                                <div class="PAMMAccountCardWordPart">
                                    <img src="@/assets/image/PAMM/PAMMAccountLogo3.svg" alt="">
                                    <div>
                                        <div
                                            class="PAMMAccountCardWordTitle subtitle-20_medium md-body-16_medium word11">
                                            专家管理</div>
                                        <div class="PAMMAccountCardWordDesc body-14_regular md-body-14_regular word12">
                                            无需主动交易，利用专家策略获利</div>
                                    </div>
                                </div>
                                <a class="primary-default_large PAMMAccountCardBtn cursor-pointer word13">立即开户连接资金</a>
                            </div>
                        </div>
                        <div class="PAMMAccountCard swiper-slide scroll-fade-up">
                            <div class="PAMMAccountCardTop">
                                <img src="@/assets/image/PAMM/PAMMAccountCardModel2.png" alt="">
                                <div class="title-24_medium md-subtitle-20_medium word14">资金管理者</div>
                            </div>
                            <div class="PAMMAccountCardBottom">
                                <div class="PAMMAccountCardWordPart">
                                    <img src="@/assets/image/PAMM/PAMMAccountLogo4.svg" alt="">
                                    <div>
                                        <div
                                            class="PAMMAccountCardWordTitle subtitle-20_medium md-body-16_medium word15">
                                            自动处理</div>
                                        <div class="PAMMAccountCardWordDesc body-14_regular md-body-14_regular word16">
                                            根据份额自动分配利润和损失</div>
                                    </div>
                                </div>
                                <div class="PAMMAccountCardWordPart">
                                    <img src="@/assets/image/PAMM/PAMMAccountLogo5.svg" alt="">
                                    <div>
                                        <div
                                            class="PAMMAccountCardWordTitle subtitle-20_medium md-body-16_medium word17">
                                            轻松管理</div>
                                        <div class="PAMMAccountCardWordDesc body-14_regular md-body-14_regular word18">
                                            简化界面，精确管理风险</div>
                                    </div>
                                </div>
                                <div class="PAMMAccountCardWordPart">
                                    <img src="@/assets/image/PAMM/PAMMAccountLogo6.svg" alt="">
                                    <div>
                                        <div
                                            class="PAMMAccountCardWordTitle subtitle-20_medium md-body-16_medium word19">
                                            透明高效</div>
                                        <div class="PAMMAccountCardWordDesc body-14_regular md-body-14_regular word20">
                                            跟踪绩效并提供透明报告</div>
                                    </div>
                                </div>
                                <div class="PAMMAccountCardWordPart">
                                    <img src="@/assets/image/PAMM/PAMMAccountLogo7.svg" alt="">
                                    <div>
                                        <div
                                            class="PAMMAccountCardWordTitle subtitle-20_medium md-body-16_medium word21">
                                            获得收入</div>
                                        <div class="PAMMAccountCardWordDesc body-14_regular md-body-14_regular word22">
                                            通过 5 种不同的费用获得额外收入</div>
                                    </div>
                                </div>
                                <a class="primary-default_large PAMMAccountCardBtn cursor-pointer word23">成为资金管理者</a>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="PAMMAccountPrincipleTitle title-32_bold md-title-24_bold text-center scroll-fade-up word24">
                    账户运作原理</div>
                <div class="PAMMAccountPrincipleDiagram scroll-fade-up">
                    <img class="PAMMAccountPrincipleDiagramImg pc" src="@/assets/image/PAMM/PAMMAccountRunPrinciple.png"
                        alt="">
                    <img class="PAMMAccountPrincipleDiagramImg mobile"
                        src="@/assets/image/PAMM/PAMMAccountRunPrincipleM.png" alt="">
                    <div class="roleManager text-center">
                        <img src="@/assets/image/PAMM/roleManager.svg" alt="">
                        <div class="subtitle-20_medium md-body-16_medium word14">资金管理者</div>
                    </div>
                    <div class="roleInvestor roleInvestor1 flex items-center justify-center">
                        <img src="@/assets/image/PAMM/roleInvestor.svg" alt="">
                        <div class="body-16_medium md-body-14_medium word6">投资者</div>
                    </div>
                    <div class="roleInvestor roleInvestor2 flex items-center justify-center">
                        <img src="@/assets/image/PAMM/roleInvestor.svg" alt="">
                        <div class="body-16_medium md-body-14_medium word6">投资者</div>
                    </div>
                    <div class="roleInvestor roleInvestor3 flex items-center justify-center">
                        <img src="@/assets/image/PAMM/roleInvestor.svg" alt="">
                        <div class="body-16_medium md-body-14_medium word6">投资者</div>
                    </div>
                </div>
                <div class="PAMMAccountPrincipleFooter footnote-regular_12 text-center scroll-fade-up word25"
                    style="color: rgba(0, 0, 0, 0.48);">
                    投资PAMM账户并非适用于所有投资者，您必须确保充分理解所涉及的风险，并根据自身的投资目标、经验水平和风险承受能力，谨慎做出投资决定。
                </div>
            </div>
        </div>
        <open-account-PAMM></open-account-PAMM>
        <section class="container4 commonQuestion">
            <div class="contentBox">
                <h2 class="scroll-fade-up title-48_bold md-title-24_bold word26">PAMM的常见问题</h2>
                <div class="QA-list">
                    <div class="QA-item">
                        <div class="QA-title subtitle-18_medium md-body-16_medium word27">1.投资者最少绑定资金是多少?</div>
                        <div class="QA-content">
                            <p class="QA-li content-16_regular md-content-14_regular word28">
                                绑定的账号至少 100 美元，且账号需为新开、无任何交易记录。
                            </p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title subtitle-18_medium md-body-16_medium word29">2.PAMM 是否支持 MT5?</div>
                        <div class="QA-content">
                            <p class="QA-li content-16_regular md-content-14_regular word30">
                                PAMM 不支持 MT5 交易账号，目前 PAMM 仅支持 MT4 Live01 和 MT4 Live02 交易账号。
                            </p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title subtitle-18_medium md-body-16_medium word31">3.投资者在待签/待连期间可以自行交易吗?</div>
                        <div class="QA-content">
                            <p class="QA-li content-16_regular md-content-14_regular word32">
                                不可以，在 PAMM 协议签署待定及连接过程中，切勿进行任何交易，以确保投资者账户无任何交易记录。
                            </p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title subtitle-18_medium md-body-16_medium word33">4.主账号有持仓时，子账号需要注意什么?</div>
                        <div class="QA-content">
                            <p class="QA-li content-16_regular md-content-14_regular word34">
                                在主账号持有交易订单时，子账号必须关注交易情况并在保证金水平不足时进行风险控制。
                            </p>
                        </div>
                    </div>
                    <div class="QA-item">
                        <div class="QA-title subtitle-18_medium md-body-16_medium word35">5.高水位线(HighWater Mark)是什么?
                        </div>
                        <div class="QA-content">
                            <p class="QA-li content-16_regular md-content-14_regular word36">
                                高水位线是由投资金额、收益与绩效费用组成的综合指标。基本上，PAMM系统会根据这一水位线来判断是否需要收取绩效费用。
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <page-footer></page-footer>
    </div>
</template>

<script>
import fadeAnimate from "../mixins/fadeAnimate.js";
export default {
    mixins: [fadeAnimate],
    data() {
        return {

        }
    },

    created() {

    },
    mounted() {
    },
    methods: {
       
    }
}
</script>

<style scoped lang="scss">
a:hover{
    color: #fff;
}
.contentBox {
    max-width: 1200rem;
    margin-inline: auto;
}

.PAMMHeader {
    height: 560rem;
    padding-top: 0rem;
    padding-left: calc(50vw - 600rem);
    gap:0rem;
    background: var(--ebc-neutral-bg_c);
}

.redW {
    color: var(--ebc-basecolor-active-500);
}

.PAMMHeaderMain {
    margin-top: 158rem;
}

.PAMMHeaderDesc {
    margin: 24rem 0 64rem;
    color: var(--ebc-text-secondary);
}

.PAMMHeaderBtn {
    width: fit-content;
    min-width: 180rem;
    box-sizing: border-box;
    margin-top: 64rem;
}

.PAMMHeaderBtn .icon-right {
    margin-left: 5rem;
}

.PAMMHeaderModel {
     width: 560rem;
    height: 560rem;
    margin-left: -70rem;
}

@media (min-width: 996px) {
    .PAMMHeaderMain {
        flex: 0 0 770rem;
  position: relative;
  z-index: 2;
    }
}

@media (max-width: 996px) {



    .PAMMHeader {
         flex-direction: column;
        padding:44rem 32rem 80rem;
        height: auto;
        overflow: hidden;
    }

    .PAMMHeaderMain {
        order: 2;
        text-align: center;
        width: 100%;

    }

    .PAMMHeaderDesc {
        margin: 16rem 0 72rem;
    }

    .PAMMHeaderModel{
        height: auto;
        width: 750rem;
        margin-left: -32rem;
        margin-top: -115rem;
    }
    .PAMMHeaderMain{
      margin-top: -40rem;
      position: relative;
      z-index: 2;
    }

    .ar .PAMMHeaderModel {
        margin-left: 0;
        margin-right: 110rem;
    }

    .ar .PAMMAccountCard:nth-child(1) {
        margin-left: 0;
        margin-right: 32rem;
    }

    .PAMMHeaderBtn {
        width: 100%;
    }

    .PAMMHeaderBtn .icon-right {
        margin-left: 12rem;
    }
}

.PAMMAccount {
    padding-block: 120rem;
    background: #fff;
}

.PAMMAccountDesc {
    margin: 16rem 0 60rem;
    color: var(--ebc-text-secondary);
}

.PAMMAccountCardList {
    gap: 48rem;
    display: flex;

}

.PAMMAccountCard {
    flex: 1;
    border-radius: var(--ebc-corner-radius-rc16);
    border: 1px solid rgba(0, 0, 0, 0.12);
    overflow: hidden;
}

.PAMMAccountCard {
    display: flex;
    flex-direction: column;
}

.PAMMAccountCardTop {
    padding: 32rem 32rem 24rem;
    text-align: center;
    background: var(--ebc-neutral-bg_b);
}

.PAMMAccountCardTop img {
    height: 100rem;
    width: auto;
    margin-bottom: 16rem;
}

.PAMMAccountCardBottom {
    flex: 1;
    padding: 32rem;
    display: flex;
    flex-direction: column;
    gap: 40rem;
}

.PAMMAccountCardWordPart {
    display: flex;
    gap: 16rem;
    align-items: center;
    padding-inline: 8rem;
}

.PAMMAccountCardWordPart img {
    width: 40rem;
    height: 40rem
}

.PAMMAccountCardWordDesc {
    margin-top: 4rem;
    color: var(--ebc-text-secondary);
}

.PAMMAccountCardBtn {
    margin-top: auto;
}

.PAMMAccountCard.swiper-slide {
    height: auto;
}

.PAMMAccountCard .PAMMAccountCardWordPart:nth-child(4) {
    margin-bottom: 16rem;
}

.PAMMAccountPrincipleTitle {
    margin: 120rem 0 48rem;
}

.PAMMAccountPrincipleDiagram {
    position: relative;
    text-align: center;
    margin-bottom: 48rem;
    width: fit-content;
    height: 315rem;
    margin-inline: auto;
}

.PAMMAccountPrincipleDiagram .PAMMAccountPrincipleDiagramImg {
    width: 516rem;
    height: 259rem;
    box-sizing: content-box;
    padding-top: 28rem;
    margin-inline: auto;
    transform: translateX(10rem);
    display: block;
}

.roleManager {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(-90%, -50%);
    border-radius: var(--ebc-corner-radius-rc08);
    border: 1px solid var(--ebc-basecolor-active-500);
    background: var(--ebc-neutral-bg_a);
    padding: 24rem;
}

.roleManager img {
    width: 40rem;
    height: 40rem;
}

.roleManager div {
    margin-top: 8rem;
    color: var(--ebc-basecolor-active-500);
}

.roleInvestor {
    position: absolute;
    right: 0;
    border-radius: var(--ebc-corner-radius-rc08);
    border: 1px solid rgba(0, 0, 0, 0.12);
    background: var(--ebc-neutral-bg_a);
    gap: 8rem;
    padding: 16rem 24rem;
    color: var(--ebc-text-secondary);
    transform: translateX(100%);
}

.roleInvestor img {
    width: 24rem;
    height: 24rem;
}

.roleInvestor1 {
    top: 0;
}

.roleInvestor2 {
    top: 50%;
    transform: translate(100%, -50%);
}

.roleInvestor3 {
    bottom: 0;
}

@media (max-width: 996px) {
    .PAMMAccount {
        padding-block: 160rem;
    }

    .PAMMAccountDesc {
        margin: 16rem 0 80rem;
        padding-inline: 32rem;
    }

    .PAMMAccountCard {
        border-radius: 24rem;
    }

    .PAMMAccountCardList {
        gap: 32rem;
        flex-direction: column;
        padding-inline: 32rem;
        box-sizing: border-box;
    }

    .PAMMAccountCardTop {
        padding: 48rem 64rem;
    }

    .PAMMAccountCardTop img {
        height: 160rem;
        margin-bottom: 32rem;
    }

    .PAMMAccountCard {
        // flex: 0 0 642rem !important;
        width: 100%!important;
    }

    // .PAMMAccountCard:nth-child(1) {
    //     margin-left: 32rem;
    // }

    .PAMMAccountCardBottom {
        padding: 64rem 32rem;
        gap: 48rem;
    }

    .PAMMAccountCardWordPart {
        gap: 32rem;
    }

    .PAMMAccountCardWordDesc {
        margin-top: 8rem;
    }

    .PAMMAccountCardWordPart img {
        height: 80rem;
        width: 80rem;
    }

    .PAMMAccountCardBottom .PAMMAccountCardBtn {
        height: 80rem;
        font-size: 28rem;
        font-weight: 500;
        line-height: 0;
    }

    .pt .PAMMAccountCardBottom .PAMMAccountCardBtn,
    .ru .PAMMAccountCardBottom .PAMMAccountCardBtn,
    .en .PAMMAccountCardBottom .PAMMAccountCardBtn,
    .es .PAMMAccountCardBottom .PAMMAccountCardBtn {
        line-height: 35rem;
        text-align: center;

    }

    .PAMMAccount-swiperPagenation {
        display: none!important;
        gap: 16rem;
        margin-top: 32rem;
        padding: 16rem 0;
    }

    .PAMMAccount-swiperPagenation div {
        border-radius: 999px;
        opacity: 0.5;
        background: var(--ebc-basecolor-active-100);
        width: 12px;
        height: 2px;
    }

    .PAMMAccount-swiperPagenation div.active {
        opacity: 1;
        width: 24px;
        background: var(--ebc-basecolor-active-500);
    }

    .PAMMAccountPrincipleTitle {
        margin: 128rem 0 80rem;
    }

    .PAMMAccountPrincipleDiagram {
        padding-inline: 32rem;
        height: 900rem;
        width: 100%;
        padding-top: 192rem;
    }

    .PAMMAccountPrincipleDiagram .PAMMAccountPrincipleDiagramImg {
        width: 100%;
        height: 584rem;
        margin: 0;
        padding: 0;
        transform: unset;
    }

    .roleManager {
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        padding: 32rem 64rem;
        border-radius: var(--ebc-corner-radius-rc16);
    }

    .roleManager img {
        width: 64rem;
        height: 64rem;
    }

    .roleManager div {
        margin-top: 16rem;
        white-space: nowrap;
    }

    .roleInvestor {
        right: unset;
        top: unset;
        bottom: 0;
        padding: 16rem 32rem;
        flex-direction: column;
        border-radius: var(--ebc-corner-radius-rc16);
        gap: 16rem;
        transform: unset;
        max-width: 28%;
    }

    .roleInvestor div {
        line-height: 35rem;
    }

    .roleInvestor img {
        width: 48rem;
        height: 48rem;
    }

    .roleInvestor1 {
        left: 32rem;
    }

    .roleInvestor2 {
        left: 50%;
        transform: translateX(-50%);
    }

    .roleInvestor3 {
        right: 32rem;
    }

    .PAMMAccountPrincipleFooter {
        padding-inline: 32rem;
        text-align: left !important;
    }
}

</style>

<style lang="scss">
@import url("../assets/css/commonQuestion.scss");


</style>